// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".lad-image.image--cover img,.lad-image.image--cover source{-o-object-fit:cover;object-fit:cover;width:100%;height:100%}.lad-image img{--aspectRatio:75%;min-height:var(--aspectRatio)}.lad-image img[height=\"100\"]{height:auto}.lad-image img[width=\"100\"]{width:100%}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
